import React from 'react';
import { useSelector } from 'react-redux';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

import { FeatureFlagsForm } from './FeatureFlagsForm';
import { LenderFeatureFlagsPortalConfiguration } from '../types';
import { PortalConfiguration, PortalConfigurationRenderProps } from '../../../types';

export const FeatureFlags = ({ loading, onSaveConfiguration }: PortalConfigurationRenderProps) => {
  const portalConfiguration = useSelector<any, PortalConfiguration<LenderFeatureFlagsPortalConfiguration>>(state =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.LenderFeatureFlags)
  );

  const handleSave = async (formData: LenderFeatureFlagsPortalConfiguration) => {
    const configToSave: PortalConfiguration<LenderFeatureFlagsPortalConfiguration> = {
      ...portalConfiguration,
      jsonDefinition: { config: formData },
    };

    await onSaveConfiguration(configToSave);
  };

  if (!portalConfiguration) return null;

  return (
    <CardContainer title="Feature Flags" sx={{ minHeight: '15rem' }}>
      <FeatureFlagsForm
        isLoading={loading}
        onConfirm={handleSave}
        defaultValues={portalConfiguration?.jsonDefinition?.config}
      />
    </CardContainer>
  );
};
